import { Menu, X, Bell, MessageCircle } from "lucide-react";
import NotificationsDropdown from "./NotificationsDropdown";

const DashboardHeader = ({
  user,
  totalBalance,
  sidebarOpen,
  setSidebarOpen,
  notificationsOpen,
  setNotificationsOpen,
  notifications,
  unreadNotifications,
  readNotifIds,
  unreadMessages,
  onMarkNotificationRead,
  onNavigate,
  onChatOpen
}) => {
  const getInitials = (name) => {
    if (!name) return "U";
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <header className="border-b border-[#1F1F1F] bg-[#0A0A0C]/80 sticky top-0 z-40">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden p-2 text-[#A1A1AA] hover:text-white transition-colors"
            data-testid="mobile-menu-btn"
          >
            {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className="flex items-center gap-3">
            {user?.avatar ? (
              <img 
                src={user.avatar} 
                alt="Avatar" 
                className="w-10 h-10 rounded-full object-cover border border-[#1F1F1F]"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-sm font-bold text-[#EDEDED]">
                {getInitials(user?.name)}
              </div>
            )}
            <div className="hidden sm:block">
              <div className="font-semibold text-white">{user?.name || "Пользователь"}</div>
              <div className="text-sm text-[#A1A1AA]">{user?.email}</div>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-4">
            <div className="hidden md:flex items-center gap-2 bg-[#0A0A0C] px-4 py-2 rounded border border-[#1F1F1F]">
              <span className="text-[#A1A1AA] text-sm">Общий баланс</span>
              <span className="font-mono text-white font-bold">$ {totalBalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>
            
            {/* Notifications Icon */}
            <NotificationsDropdown
              notificationsOpen={notificationsOpen}
              setNotificationsOpen={setNotificationsOpen}
              notifications={notifications}
              unreadNotifications={unreadNotifications}
              readNotifIds={readNotifIds}
              onMarkNotificationRead={onMarkNotificationRead}
              onNavigate={onNavigate}
            />
            
            {/* Chat Icon */}
            <button 
              className="p-2 text-[#A1A1AA] hover:text-white transition-colors relative"
              onClick={onChatOpen}
            >
              <MessageCircle size={20} />
              {unreadMessages > 0 && (
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#F87171] rounded-full text-white text-xs flex items-center justify-center">
                  {unreadMessages}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
